const name = require("./name");
const { isStringValid } = require("simpul");

const defaultHashtag = name.main; // || "all"

const hashtagConfig = {
  default: defaultHashtag,
  isDefault: (hashtag) =>
    !isStringValid(hashtag) || hashtag.trim().toLowerCase() === defaultHashtag,
  valueify: (hashtag) => (hashtag ? hashtag.toString().split(" ")[0] : ""),
  delimiters: [{ replace: " ", with: "_" }],
};

module.exports = hashtagConfig;
